<template>
  <v-form ref="specialistCreationForm" v-model="isValid">
    <v-text-field
      v-model="newSpecialist.name"
      label="Name"
      :rules="nameRules"
      required
    ></v-text-field>
    <v-text-field
      v-model="newSpecialist.position"
      label="Position"
      :rules="positionRules"
      required
    ></v-text-field>
    <v-text-field
      v-model="newSpecialist.phone"
      label="Phone"
      :rules="phoneRules"
      required
    ></v-text-field>
    <v-text-field
      v-model="newSpecialist.email"
      label="Email"
      :rules="emailRules"
      required
    ></v-text-field>
    <v-text-field
      v-model="newSpecialist.comment"
      label="Comment"
      :rules="commentRules"
      required
    ></v-text-field>
    <v-text-field
      v-model="newSpecialist.externalId"
      label="External Id"
      :rules="externalIdRules"
    ></v-text-field>
    <v-select
      :items="availableSpecialistRole"
      v-model="newSpecialist.role"
      item-value="value"
      item-text="name"
      label="Role"
      persistent-hint
      required
    ></v-select>
    <v-checkbox
      v-model="newSpecialist.inviteToDpCases"
      label="Invite to DP cases"
    ></v-checkbox>
    <v-alert
      :value="hasError"
      type="error"
      outline
    >
      {{ errorMessage }}
    </v-alert>
    <v-btn
      :disabled="!isValid"
      @click="handleOkClick"
    >
      Create
    </v-btn>
    <v-btn @click="handleCancelClick">Cancel</v-btn>
  </v-form>
</template>

<script>
import _ from 'lodash'
import api from '../../api'
import {extractErrorToString} from '../../helpers/api'
import {validateStringLength} from '../../helpers/validation'

const emptySpecialist = {
  name: null,
  position: null,
  phone: null,
  email: null,
  comment: null,
  externalId: null,
  inviteToDpCases: false,
  role: 'specialist'
}

export default {
  name: 'specialist-creation-form',
  props: {
    clientId: {
      type: String
    },
    availableSpecialistRole: {
      type: Array
    }
  },
  data () {
    return {
      hasError: null,
      processing: false,
      isValid: false,
      errorMessage: null,
      newSpecialist: _.clone(emptySpecialist),
      nameRules: [
        v => !!v || 'Enter specialist name',
        _.partial(validateStringLength, _, 255, 'The length of the name should be no more than 255 characters')
      ],
      positionRules: [
        _.partial(validateStringLength, _, 255, 'The length of the position should be no more than 255 characters')
      ],
      phoneRules: [
        _.partial(validateStringLength, _, 100, 'The length of the position should be no more than 100 characters')
      ],
      emailRules: [
        _.partial(validateStringLength, _, 100, 'The length of the email should be no more than 100 characters'),
        function (value) {
          if (!value) {
            return true
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      ],
      commentRules: [
        _.partial(validateStringLength, _, 1000, 'The length of the comment should be no more than 1000 characters')
      ],
      externalIdRules: [
        _.partial(validateStringLength, _, 1000, 'The length of the externalId should be no more than 255 characters')
      ]
    }
  },
  beforeCreate () {

  },
  watch: {},
  mounted () {
  },
  methods: {
    async handleOkClick () {
      if (this.processing) {
        return
      }

      this.startProcessing()
      this.hasError = null
      this.errorMessage = null
      try {
        this.newSpecialist.clientId = this.clientId
        let createdSpecialist = await api.createClientSpecialist(this.newSpecialist)
        this.resetNewSpecialist()
        this.$emit('created', createdSpecialist)
        this.stopProcessing()
      } catch (e) {
        this.hasError = true
        this.errorMessage = extractErrorToString(e, 'Unable to create client specialist')
        this.stopProcessing()
      }
    },
    handleCancelClick () {
      this.resetNewSpecialist()
      this.$emit('close')
    },
    resetNewSpecialist () {
      this.hasError = null
      this.errorMessage = null
      this.$refs.specialistCreationForm.reset()
      this.newSpecialist = _.clone(emptySpecialist)
    },
    startProcessing () {
      this.processing = true
      this.$emit('startProcessing')
    },
    stopProcessing () {
      this.processing = false
      this.$emit('stopProcessing')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/SpecialistCreationForm.vue